/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionDetailsSelections
 */
export interface BidirectionalActionDetailsSelections {
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionDetailsSelections
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionDetailsSelections
     */
    selected_option: string;
}

/**
 * Check if a given object implements the BidirectionalActionDetailsSelections interface.
 */
export function instanceOfBidirectionalActionDetailsSelections(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "selected_option" in value;

    return isInstance;
}

export function BidirectionalActionDetailsSelectionsFromJSON(json: any): BidirectionalActionDetailsSelections {
    return BidirectionalActionDetailsSelectionsFromJSONTyped(json, false);
}

export function BidirectionalActionDetailsSelectionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionDetailsSelections {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selected_option': json['selected_option'],
    };
}

export function BidirectionalActionDetailsSelectionsToJSON(value?: BidirectionalActionDetailsSelections | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'selected_option': value.selected_option,
    };
}

